import { getStaticConfig } from '@ms/yammer-libs-static-config';
import { doesAuthenticatorSupportScopes, getAuthenticator } from '@ms/yammer-web-authenticators';

import type { ManagedApiRequest } from './types';

const getResources = ({ resource }: ManagedApiRequest) => [resource ?? getStaticConfig().adal.resources.yammer];

const getScopes = ({ scopes }: ManagedApiRequest) => scopes ?? [getStaticConfig().adal.resources.yammer];

type GetResourcesOrScopes = (request: ManagedApiRequest) => string[];
export const getResourcesOrScopes: GetResourcesOrScopes = (request) =>
  doesAuthenticatorSupportScopes(getAuthenticator()) ? getScopes(request) : getResources(request);
